export default __webpack_public_path__ + "static/media/Metropolis-ThinItalic.4f80c943.otf";